import createBuildtimeConfigMock from '~/config/mocks/buildtime-config-mocks'
import createRuntimeConfigMock from '~/config/mocks/runtime-config-mocks'
import BuildtimeConfigBuilder from '~/config/services/BuildtimeConfigBuilder'
import RuntimeConfigBuilder from '~/config/services/RuntimeConfigBuilder'
import AppDeps from '~/core/model/AppDeps'
import AppDepsBuilder from '~/core/services/AppDepsBuilder'

// eslint-disable-next-line import/no-mutable-exports
let appDeps: AppDeps

async function startAppCore() {
  const forceEnv = new URLSearchParams(window.location.search).get('x-param-env') || undefined

  const buildtimeConfig = new BuildtimeConfigBuilder().getBuildtimeConfig()
  const runtimeConfig = await new RuntimeConfigBuilder().getRuntimeConfig(forceEnv)
  appDeps = new AppDepsBuilder(buildtimeConfig, runtimeConfig).buildAppDeps()

  return appDeps
}

function startAppCoreMock() {
  const buildtimeConfig = createBuildtimeConfigMock()
  const runtimeConfig = createRuntimeConfigMock()
  appDeps = new AppDepsBuilder(buildtimeConfig, runtimeConfig).buildAppDeps()

  return appDeps
}

export { appDeps, startAppCore, startAppCoreMock }
